// extracted by mini-css-extract-plugin
export default {"week":"Week_week__6pnhH"};